import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MessagingThreadState {
  unreadMessageCount: number;
  selectedThreadId: string;
  threadsListVersion: number;
  threadDetailsVersion: number;
}

const initialState: MessagingThreadState = {
  unreadMessageCount: 0,
  selectedThreadId: "",
  threadsListVersion: 0,
  threadDetailsVersion: 0,
};

const messagingThreadSlice = createSlice({
  name: "messagingThread",
  initialState,
  reducers: {
    setUnreadMessageCount: (state, action: PayloadAction<number>) => {
      state.unreadMessageCount = action.payload;
    },
    setSelectedThreadId: (state, action: PayloadAction<string>) => {
      state.selectedThreadId = action.payload;
    },
    refreshThreadsList: (state) => {
      state.threadsListVersion += 1;
    },
    refreshThreadsDetails: (state) => {
      state.threadDetailsVersion += 1;
    },
  },
});

export const {
  setUnreadMessageCount,
  setSelectedThreadId,
  refreshThreadsList,
  refreshThreadsDetails,
} = messagingThreadSlice.actions;

export const selectUnreadMessageCount = (state: any) =>
  state.messagingThread.unreadMessageCount;

export const selectSelectedThreadId = (state: any) =>
  state.messagingThread.selectedThreadId;

export const selectThreadsListVersion = (state: any) =>
  state.messagingThread.threadsListVersion;

export const selectThreadDetailsVersion = (state: any) =>
  state.messagingThread.threadDetailsVersion;

export default messagingThreadSlice;
